import {I18nLang} from 'ngx-satoris';
import {DocumentType} from 'src/app/shared/models/user';

export const environment = {
  production: false,
  appVersion: [1, 1, 2],
  appBuild: 'build-localhost',

  baseUri: 'https://ep-api-dev.satoris.lu/api/v1/',
  backupUri: <string>undefined,
  authUri: <string>undefined,
  referenceUri: <string>undefined,

  name: 'PayCode',
  supportSource: 'https://glpi-app.satoris.lu/install.js?project=paycode&lang=fr&position=bottomRight&btnVisible=false',
  faqSource: <string>undefined,
  travizorySource: 'http://apipnr.testzimmigration.local',

  smsIntent: 'INTENT',

  theme: {
    logo: 'assets-projects/logo.svg',
    logoFullAlt: 'assets-projects/logo-full-alt.png',
    header_background: ''
  },
  type: DocumentType.PASS,
  supportedLanguages: [I18nLang.EN, I18nLang.FR],
  nationalityNoDeclaration: ['ZWE'],
  supportedCurrencies: ['USD', 'EUR', 'ZWL', 'GBP', 'BWP'],
  noRegister: false
};
